import { Word } from 'models'
import { FC, useMemo } from 'react'
import { Swiper, SwiperSlide } from 'swiper/react'
import 'swiper/css'

import { useAppContext } from 'context/app-context'
import { FilterButton, List } from './styled'

export type Filter = Word['category_possibly'] | ''

type Props = {
  activeFilter: Filter
  onChange: React.Dispatch<React.SetStateAction<Filter>>
  words: Word[] | null
}

export const Filters: FC<Props> = ({ words, activeFilter, onChange }) => {
  const { colors } = useAppContext()

  const filters = useMemo(() => {
    const sortingArray = [
      'җәмгыять',
      'сәясәт',
      'икътисад',
      'фән',
      'хәрби',
      'география',
      'көнкүреш',
      'башка',
      'башкалар',
    ]

    return [
      ...new Set(words?.map(w => w?.category_possibly).filter(f => !!f)),
    ].sort((b, a) => sortingArray.indexOf(b) - sortingArray.indexOf(a))
  }, [words])

  return (
    <List>
      <Swiper slidesPerView="auto" slideToClickedSlide draggable>
        <SwiperSlide>
          <FilterButton
            as="span"
            tabIndex={0}
            $active={!activeFilter}
            onClick={() => onChange('')}
          >
            барсы
          </FilterButton>
        </SwiperSlide>
        {filters.map(filter => (
          <SwiperSlide key={filter}>
            <FilterButton
              as="span"
              key={filter}
              onClick={() => onChange(filter)}
              $active={activeFilter === filter}
              $color={
                colors && filter in colors
                  ? colors[filter as keyof typeof colors]
                  : ''
              }
            >
              {filter}
            </FilterButton>
          </SwiperSlide>
        ))}
      </Swiper>
    </List>
  )
}
